import { render } from "./Menu.vue?vue&type=template&id=e3fea70e&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=e3fea70e&lang=css"

import exportComponent from "C:\\Users\\Aikana\\Workspace\\WebsiteVue\\website_aw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__